import { render, staticRenderFns } from "./DeniedContracts.vue?vue&type=template&id=2c896973&"
import script from "./DeniedContracts.vue?vue&type=script&lang=js&"
export * from "./DeniedContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports